var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4721 4.47157C12.7324 4.21122 12.7324 3.78911 12.4721 3.52876C12.2117 3.26841 11.7896 3.26841 11.5292 3.52876L8.00065 7.05735L4.47206 3.52876C4.21171 3.26841 3.7896 3.26841 3.52925 3.52876C3.2689 3.78911 3.2689 4.21122 3.52925 4.47157L7.05784 8.00016L3.52925 11.5288C3.2689 11.7891 3.2689 12.2112 3.52925 12.4716C3.7896 12.7319 4.21171 12.7319 4.47206 12.4716L8.00065 8.94297L11.5292 12.4716C11.7896 12.7319 12.2117 12.7319 12.4721 12.4716C12.7324 12.2112 12.7324 11.7891 12.4721 11.5288L8.94346 8.00016L12.4721 4.47157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.2a9827f498b5d7d695b75fd1691539d2.svg";
export { ForwardRef as ReactComponent };